import React from 'react';
import { useSelector } from 'react-redux';
import { IRootState } from '../../reducer';
import InstructorContainer from '../InstructorContainer/InstructorContainer';
import image from '../../img/questionsPageNotLogged.jpg';
import CategoryContainer from '../CategoryContainer/CategoryContainer';
import { RulesGroupContent } from '../../ui-components/RulesGroupContent/RulesGroupContent';
import styles from './QuestionsBgContainer.module.css';

const QuestionsBgContainer: React.FC = () => {
  const isLogged = useSelector(({ login }: IRootState) => login.isLogged);
  const instructor = useSelector(({ user }: IRootState) => user.profile.drivingInstructor);

  if (isLogged && instructor) {
    return (
      <div className={styles.questionsBgContainer}>
        <RulesGroupContent>
          <div className={styles.imageBox}>
            <InstructorContainer src={image} hideForMobile />
          </div>
          <CategoryContainer />
        </RulesGroupContent>
      </div>
    );
  }
  return (
    <RulesGroupContent>
      <InstructorContainer src={image} hideForMobile />
      <CategoryContainer />
    </RulesGroupContent>
  );
};

export default QuestionsBgContainer;
